<template>
	<div>
		<navTitle>
			<div class="flex flex-align-center flex-jus-center">
				<div class="selectCenter flex flex-align-center flex-jus-center">
					<span>{{majorName ? majorName : '请选择'}}</span>
				</div>
			</div>
		</navTitle>
		<div class="imgBox">
			<swiper ref="myHomeSwiper" class="home-swiper" :options="swiperOptions">
				<swiper-slide v-for="item in bannerList" :key="item.id" class="home-swiper-slide">
					<img class="titleImg" :src="item.image" alt="" />
				</swiper-slide>
			</swiper>
		</div>

		<template v-if="dataList.length">
			<van-list
				v-model="loading"	
				:finished="finished"
				:immediate-check="false"
				finished-text="没有更多了"
				@load="onLoad"
				:offset="10"
			>
				<div class="videoList flex flex-align-center flex-jus-between flex-wrap">
					<div class="videoItem" v-for="item in dataList" :key="item.id">
						<videoItem :cover="item.pic ? item.pic : item.video + '?vframe/jpg/offset/0'" type="1" :id="item.article_id" :width="167" :height="111" :content="item.title" :videoSrc="item.video"></videoItem>
					</div>
				</div>
			</van-list>
		</template>
		<template v-else>
			<div class="empty">
				<div class="empty-img">
					<img src="@/static/images/index/emptySearch.png" alt="">
				</div>
				<div class="empty-text">暂无视频</div>
			</div>
		</template>
		
		<resourcesPop :majorId="majorId" :resourcesPopShow.sync="resourcesPopShow" @changeResourcesPop="changeResourcesPop"></resourcesPop>
	</div>
</template>

<script>
import videoItem from '@/views/components/videoItem.vue';
import resourcesPop from '@/views/components/resourcesPop.vue';
/* eslint-disable */
export default {
	components: {
		videoItem,
		resourcesPop
	},
	data() {
		return {
			bannerList: [],
			swiperOptions: {
				autoplay: {
					delay: 3000 //3秒切换一次
				},
				pagination: {
					el: '.swiper-pagination'
				}
			},
			majorId: '',
			majorName: '',
			page: 1,
			loading: false,
      finished: false,
      dataList: [],
			resourcesPopShow: false,
		};
	},
	created() {
		this.majorId = this.$route.query.id || localStorage.getItem('majorId') || ''
		this.majorName = this.$route.query.name || localStorage.getItem('majorName') || ''
		this.getBanner()
		this.getList()
	},
	mounted() {
		this.$wx.ready(() => {
      this.$wx.updateAppMessageShareData({
        title: '福建省民族管弦乐学会',
        desc: '学习资源',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
      this.$wx.updateTimelineShareData({
        title: '福建省民族管弦乐学会',
        link: location.href,
        imgUrl: 'http://guan.xuanyue.zaihukeji.cn/uploads/wx_share.png'
      })
    });
	},
	methods: {
		getBanner() {
			this.$get('api/common/getBanner', {
				type: 3
			}).then(res => {
				this.bannerList = res.data
			})
		},
		changeResourcesPop(data) {
			this.majorId = data.id
			this.majorName = data.name
			localStorage.setItem('majorId', this.majorId)
			localStorage.setItem('majorName', this.majorName)
			this.resourcesPopShow = false
		},
		getList() {
			this.$get('api/actile/getLearningResourceVideoList', {
				major_id: this.majorId,
				pageSize: 10,
				page: this.page
			}).then(res => {
				this.loading = false;
        let rows = res.data;
        if (rows == null || rows.length === 0) {
          this.finished = true;
          return;
        }
        this.dataList = this.dataList.concat(rows);

			})
		},
		onLoad() {
			this.page++;
      if (this.page > 1) {
        this.getList();
      }
		},
	}
};
</script>

<style scoped lang="stylus">
.imgBox
	width 690px	
	height 222px
	margin-bottom 40px
	margin 24px 30px
	img
		border-radius 24px
		overflow hidden
		width 690px
		height 222px
		object-fit: cover;
.selectCenter
	margin 0 auto
	min-width 160px
	height 64px
	border 2px solid #FFFFFF
	border-radius 38px
	font-size 28px
	color #FFFFFF
	padding 0 12px
	span
		word-break keep-all
	img
		margin-left 8px
		width 12px
		height 22px
.videoList
	padding 24px 30px
	.videoItem
		margin-bottom 28px
.empty
	background-color inherit
	.empty-img
		margin 280px auto 0 auto
		width 373px
		height 320px
		img
			width 100%
			height 100%
	.empty-text
		width 100%
		text-align center
		margin-top 22px
		font-size: 26px;
		color: #111111;
</style>
